<template>
	<div  class="scrollable only-y" style="margin : 0 auto;" v-loading.fullscreen.lock="fullScreenLoading">
		<div class="customer-top-nav">
			<el-page-header @back="close()" style="float:left;">
				<div slot="title">
					<span class="hidden-sm-and-down">Retour</span>
				</div>
				<div slot="content">
					<span >{{getContactName()}}</span>
				</div>
			</el-page-header>
			<div class="customer-controls">
				<el-dropdown v-if="$can('write','Contacts')">
					<el-button type="primary">
						Actions <i class="el-icon-arrow-down"></i>
					</el-button>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item @click.native="openUpdateContact" ><i class="mdi mdi-account-edit"><span style="padding-left:5px;">Modifier la fiche contact</span></i></el-dropdown-item>
						<el-dropdown-item @click.native="openClient"  :disabled="contact.customer.id==null"><i class="mdi mdi-account-circle"><span style="padding-left:5px;">Ouvrir la fiche client</span></i></el-dropdown-item>
						<el-dropdown-item @click.native="createClient" :disabled="contact.customer!=null"><i class="mdi mdi-account-circle"><span style="padding-left:5px;">Créer une fiche client individuel</span></i></el-dropdown-item>
						<el-dropdown-item @click.native="updateAccessWeb">
							<i class="mdi mdi-web">
								<span v-if="contact.web_access==false" style="padding-left:5px;">Attribuer un accès web</span>
								<span v-else style="padding-left:5px;">Retirer l'accès web</span>
							</i>
						</el-dropdown-item>
						<el-dropdown-item :divided="true" :disabled="!canDelete"><i class="mdi mdi-delete" @click="deleteContact"><span style="padding-left:5px;">Supprimer le contact</span></i></el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
			</div>
		</div>
		<!-- Individual form -->
			<el-card class="box-card" >
				<div style="width:100%;text-align:center;">
			    <el-radio-group v-model="activeTab">
			      <el-radio-button label="1"><i class="el-icon-user"/><span class="hidden-md-and-down">Fiche contact</span></el-radio-button>
			      <el-radio-button label="2"><i class="el-icon-shopping-cart-full"/><span class="hidden-md-and-down">Ventes</span></el-radio-button>
			      <el-radio-button label="3"><i class="el-icon-postcard"/><span class="hidden-md-and-down">Communications</span></el-radio-button>
			      <el-radio-button label="4"><i class="el-icon-files"/><span class="hidden-md-and-down">Notes</span></el-radio-button>
			    </el-radio-group>
			  </div>
				<div v-if="activeTab==1">
					<!-- Information sur le contact -->
					<el-form ref="individualContactForm" :model="contact" style="max-width:1000px;" label-position="left">
						<h5>Information sur le contact</h5>
						<el-divider/>
						<el-row :gutter="20">
							<el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
								<span class="fs-14" style="color:#606266">Genre : </span>
								<span class="fs-14" v-if="contact.sex==1">Homme</span>
								<span class="fs-14" v-if="contact.sex==0">Femme</span>
								<span class="fs-14" v-if="contact.sex==2">Autre</span>
							</el-col>

							<el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
								<span class="fs-14" style="color:#606266">Titre : </span>
								<span class="fs-14" v-if="denomination!=''">{{denomination}}</span>
								<span class="fs-14" v-else>S.O.</span>
							</el-col>
						</el-row>
						<el-row :gutter="20">
							<el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
								<span class="fs-14" style="color:#606266">Prénom : </span>
								<span class="fs-14">{{contact.first_name}}</span>
							</el-col>

							<el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
								<span class="fs-14" style="color:#606266">Nom : </span>
								<span class="fs-14">{{contact.last_name}}</span>
							</el-col>
						</el-row>
						<el-row :gutter="20">
							<el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
								<span class="fs-14" style="color:#606266">Courriel : </span>
								<span class="fs-14">{{contact.email}}</span>
							</el-col>
							<el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
								<span class="fs-14" style="color:#606266">Téléphone : </span>
								<span class="fs-14">{{contact.phone}}</span>
								<span class="fs-14" v-if="contact.phone_ext!=null && contact.phone_ext!=''"> Ext. : {{contact.phone_ext}}</span>
							</el-col>
						</el-row>
						<el-row :gutter="20" v-if="contact!=null">
							<el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
								<span class="fs-14" style="color:#606266">Étiquettes : </span>
								<span class="fs-14"><el-tag style="margin-left:5px;" v-for="tag in contact.tags" :key="tag.id" >{{tag.code}}</el-tag></span>
							</el-col>
						</el-row>
						<el-row :gutter="20">
							<el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
								<span class="fs-14"  style="color:#606266"> Numéro de client : </span>
								<span v-if="contact.customer.id!=null"><el-button type="text" @click="openClient">{{contact.customer.id}}</el-button></span>
								<span v-else><el-button @click="createClient" size="small">Créer une fiche client</el-button></span>
							</el-col>
						</el-row>

						<h5>Adresses</h5>
						<el-divider/>
						<el-row :gutter="20">
							<el-col v-for="(address, index) in getAddresses" :key="index" :xs="24" :sm="24" :md="24" :lg="12" :xl="12" style="padding:10px;margin-bottom:10px">
								 <AddressCard :address="address" :index="index" :ctrlVisible="false"></AddressCard>
							</el-col>
						 <div v-if="getAddresses!=null && getAddresses.length==0" class="fs-14" style="margin:20px;">Il n'y a aucune adresse de spéficiée</div>

						</el-row>
						<h5>Organisations</h5>
						<el-divider/>
						<el-row>
							<el-col v-for="(company, index) in getActiveCompanies" :key="index" :xs="24" :sm="24" :md="24" :lg="12" :xl="12" style="padding:5px;">
								 <ContactCompanyCard :company="company" shadow="never"></ContactCompanyCard>
							</el-col>
							<span v-if="getActiveCompanies.length==0">Le contact est présentement associé à aucune organisation.</span>
						</el-row>
						<h6>Historique</h6>
						<el-row>
							<el-col v-for="(company, index) in getHistoricCompanies" :key="index" :xs="24" :sm="24" :md="24" :lg="12" :xl="12" style="padding:5px;">
								 <ContactCompanyCard :company="company" shadow="never"></ContactCompanyCard>
							</el-col>
							<span v-if="getHistoricCompanies.length==0" class="fs-14">Le contact est présentement associé à aucune organisation.</span>
						</el-row>
					</el-form>

				</div>
				<div v-if="activeTab==2">
					<h4>{{$t('clients.currentSalesOrder')}}</h4>
					<div class="flex center m-10 mt-10">
						<Pagination
							class="box right mt-5 mb-0 fs-14 secondary-text"
							:current-page="page"
							:total-number-of-page="totalPages"
							@click-previous="fetchPreviousSalesOrderPage"
							v-if="isNotEmpty"
							@click-next="fetchNextSalesOrderPage" />
					</div>
					<el-divider/>
					<salesOrderTable :salesOrders="salesOrders" height="100%" class="mb-20"></salesOrderTable>
				</div>
				<div v-if="activeTab==3">
					<!-- <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="18"> -->
						<h4>Interactions</h4>
						<EmailsCommunicationTable :lazy="true" :contactId="contactId"></EmailsCommunicationTable>
					<!-- </el-col> -->
				</div>
				<div v-if="activeTab==4">
					<el-row>
						<el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
							<h5>Notes</h5>
							<el-divider/>
							<ContactNoteHistory :contactId="contactId"></ContactNoteHistory>
						</el-col>
						<el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
							<h5>Notes rapides</h5>
							<el-divider/>
							<QuickNote :contactId="contactId"></QuickNote>
						</el-col>

					</el-row>
				</div>

			</el-card>
			<ContactEditor :contactToEdit="contactToEdit" :visible="showContactEditor" @close="closeContactEditor" @edited="contactEdited"></ContactEditor>
	</div>
</template>

<script>
import axios from "axios"
import AddressCard from '@/components/address/Address-Card'
import ContactCompanyCard from '@/components/Contact-company-card'
import QuickNote from '@/components/Quick-note-component.vue'
import ContactEditor from '@/components/contact/contact-editor'
import contactAPI from '@/services/API/contact'
import salesOrderTable from '@/components/dashboards/sales-order/sales-order-table.vue'
import Pagination from '@/components/pagination'
import SalesOrdersAPI from '@/services/API/sales-order'
import { mapActions } from 'vuex';

export default {
  data() {
    return {

		activeNames: ['individual-identification','individual-address','active-organisation'],
	  	contact : {
			first_name : null,
			last_name : null,
			addresses : [],
			archived : null,
			denomination : null,
			companies : [],
			email : null,
			phone : null,
			tags : [],
			web_access : null,
			customer:{id:null}
		},
		contactToEdit : null,
		showContactEditor : false,
	  	fullScreenLoading: true,
		countries : [],
	  	states : [],
		activeTab : '1',
	  	loading:false,
		page: 1,
		totalPages: 0,
		salesOrderLimit: 25,
		salesOrders: [],
    };
  },components: {
		salesOrderTable,
		Pagination,
        AddressCard,
		ContactCompanyCard,
		QuickNote,
		ContactEditor,
		ContactNoteHistory : () => import('@/components/note-history.vue'),
		EmailsCommunicationTable : () => import('@/components/emails/emails-communication-table.vue'),
  },
	methods: {
		fetchNextSalesOrderPage () {
			if (this.page < this.totalPages) {
				this.page += 1;
				this.getSalesOrders();
			}
		},
		fetchPreviousSalesOrderPage () {
			if (this.page > 1) {
				this.page -= 1;
				this.getSalesOrders();
			}
		},
		getSalesOrders(){
			SalesOrdersAPI.fetchSalesOrders({paging:'true',page: this.page, limit: this.salesOrderLimit, billingContactId:this.contactId, shippingContactId:this.contactId, orderBy: 'date', direction: 'desc'}, ['customer'])
				.then(salesOrders=>{
					console.log('SalesOrders : ', salesOrders);
					this.totalPages = salesOrders.pages;
					this.salesOrders = salesOrders.list;
				})
		},
		deleteContact () {
			if (this.customerId== null) {
				contactAPI.deleteContact(this.contactId)
				.then(() => {
					this.$message.success(this.$i18n.t('contacts.contactDeleted'));
					this.$store.dispatch('CONTACTS_INVALIDATE_LIST');
					this.close();
				}).catch(err=>{
					this.$message.error(this.$i18n.t('contacts.errors.cannot_delete_contact'));
				})
			} else {
				this.$message.error(this.$i18n.t('contacts.errors.cannot_delete_due_to_customer_file'));
			}

		},
		contactEdited(contact){
			this.closeContactEditor();
			Object.assign(this.contact, contact);
		},
		getContactName(){
			if((this.contact.first_name==null || this.contact.first_name=='') &&  (this.contact.last_name==null || this.contact.last_name=='')){
				return "Unnamed contact";
			}
			return this.contact.first_name + ' ' + this.contact.last_name;
		},
		close(){
			this.$router.go(-1);
		},
		canEditIndividualInfo(){
			return false;
		},
		openCustomer(customerId){
			this.$router.go(-1);
		},
		openUpdateContact(){
			this.contactToEdit = _.cloneDeep(this.contact);
			this.showContactEditor=true;
			// var index='/contacts/contact-form/'+this.contactId;
			// this.$router.push(index);
		},
		closeContactEditor(){
			this.showContactEditor=false;
			this.contactToEdit=null;
		},
		openClient(){
			var index='/customers/'+this.contact.customer.id;
			this.$router.push(index);
		},
		createClient(){
			let customer = {};
			customer.contacts = [];
			customer.contacts.push(this.contact);
			customer.type=0;
			return axios.post(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/customers", customer)
				.then(response=>{
					this.contact.customer.id=response.data.id;
				})
		},
		getContact(){
			return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/contacts/"+this.contactId)
				.then(response=> {
					if(response.data.customer==null){
						response.data.customer= {};
						response.data.customer.id = null;
					}
					Object.assign(this.contact, response.data);
				})
		},
		updateAccessWeb(){
			return axios.put(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/contacts/"+this.contact.id, {id:this.contact.id,web_access:!this.contact.web_access})
        .then(response=>{
					if(this.contact.web_access){
						this.contact.web_access = false;
						this.$message.success("L'accès web a été retiré.");
					}else{
						this.contact.web_access = true;
						this.$message.success("L'accès web a été attribué.");
					}
        })
		},
	},
	computed: {
		canDelete(){
			return this.customerId == null;
		},
		isNotEmpty () {
			return _.size(this.salesOrders) > 0;
		},
		denomination(){
			if(this.contact==null || this.contact.denomination==null) return "";

			let denomination = _.find(this.contact.denomination.languages, l=>{return l.code == this.lang})
			// console.log(denomination);
			return denomination.name;

		},
		customer(){
			return _.get(this.contact,'customer'); 
		},
		customerId () {
			return _.get(this.contact,'customer.id');
		},
		lang(){
			return this.$i18n.locale;
		},
		contactId(){
			return this.$route.params.id;
		},
		getAddresses(){
			return this.contact.addresses;
		},
		getActiveCompanies(){
			if(this.contact==null || this.contact.companies==null)return [];
			return this.contact.companies.filter(company=> company.active==true);
		},
		getHistoricCompanies(){
			if(this.contact==null || this.contact.companies==null)return [];
			return this.contact.companies.filter(company=> company.active!=true);
		},
		isAssociatedToClient(){
			return this.customerId != null;
		}

	},
	mounted(){
		this.getSalesOrders();
	},
	created(){
		this.getContact()
			.then(()=>{
					this.fullScreenLoading=false;
			});
	}
}
</script>

<style lang="scss" scoped>
@import '../../../assets/scss/_variables';



.title {
  	font-size : 1.6em;
  	font-weight:bold;
  	margin-right:20px;
  	position:relative;
  	float:left;
  }

 .customer-top-nav{
 	height:50px;
 }

.customer-settings{
	font-size : 2.0em;
	position:relative;
	margin-left:20px;
  	float:left;
  	margin-top:-5px;
  	color:#9AA2AC;
}


.customer-controls{
	position:relative;
	float:right;

	button{
		margin-left:20px;
	}
}


.box-card{
	margin-top:10px;
	padding:10px;
	margin-bottom:10px;
}
.dotted-card{
	border: 2px dashed #D1CFCF;
	background-color: rgba(216,216,216,0.1);
	font-family: Helvetica-Bold;
	font-size: 14px;
	letter-spacing: 0.32px;
	text-align: center;
	color:#9AA2AC;
	margin-bottom:20px;
}

.el-card__body, .el-card{
	position:relative;
}

.dotted-card:hover{
	cursor:pointer;
	color: #4A596A;
}

.el-row{
	margin-bottom:0px;
}

.el-select{
	width:100%;
}

.client-info{
 	margin:5px;
 }
.client-name{
  	font-size:1.5 em;
  	color:#4a596a;
  }
.card-info{
	margin:20px;
	color:#a9aaad;
}
</style>
